export type NotificationType = 'order' | 'payment' | 'delivery' | 'promotion' | 'system' | 'support' | 'inventory';

export interface NotificationItem {
  id: string;
  title: string;
  message: string;
  type: NotificationType;
  timestamp: string;
  isRead: boolean;
}

export function getUnreadCount(items: NotificationItem[]): number {
  return items.filter((n) => !n.isRead).length;
}

export function filterNotifications(
  items: NotificationItem[],
  filter: 'all' | 'unread' | NotificationType
): NotificationItem[] {
  if (filter === 'all') return items;
  if (filter === 'unread') return items.filter((n) => !n.isRead);
  return items.filter((n) => n.type === filter);
}
